import { Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { IconEmail, IconPerson, IconPhone } from 'assets/img';
import { getWorkerFullName } from 'shared/utils/worker';

const AVATAR_SIZE = 64;

type EmployeeCardProps = {
  id: string;
  firstName: string;
  infix?: string | null;
  lastName: string;
  email: string;
  phone: string | null;
  profilePictureUrl?: string;
  isOnboarded?: boolean;
  onClick: () => void;
};

export const EmployeeCard = (props: EmployeeCardProps) => {
  return (
    <Card onClick={props.onClick}>
      <Box display="flex" flexDirection="row" alignItems="center" gap={4}>
        <StyledAvatar src={props.profilePictureUrl} />
        <EmployeeName>{getWorkerFullName(props)}</EmployeeName>
      </Box>
      <Box display="flex" flexDirection="column" gap="16px">
        <EmployeeDetailLine>
          <IconEmail />
          <EmployeeDetail>{props.email}</EmployeeDetail>
        </EmployeeDetailLine>
        <EmployeeDetailLine>
          <IconPhone />
          <EmployeeDetail>{props.phone}</EmployeeDetail>
        </EmployeeDetailLine>
        <EmployeeDetailLine>
          <IconPerson />
          <EmployeeDetail>{props.isOnboarded ? 'Onboarded' : 'Not onboarded'}</EmployeeDetail>
        </EmployeeDetailLine>
      </Box>
    </Card>
  );
};

const Card = styled(Box)(({ theme, onClick }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3),
  gap: theme.spacing(3),
  borderRadius: theme.spacing(4),
  boxShadow: '0px 12px 16px 0px #33333314',
  cursor: onClick ? 'pointer' : 'auto',
}));

const EmployeeName = styled(Typography)({
  fontSize: '20px',
  fontVariationSettings: '"wght" 700',
  fontFamily: 'Urbanist',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const EmployeeDetail = styled(Typography)({
  fontSize: '16px',
  fontFamily: 'Inter',
  fontVariationSettings: '"wght" 500',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const EmployeeDetailLine = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
}));

const StyledAvatar = styled(Avatar)({
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
});
